module.exports = __webpack_public_path__ + "static/media/case_11.85eed07a.jpg";